import React from 'react'

export default class IconsNone extends React.Component {
    render() {
        let color = '#000000'
        if (this.props.color) color = this.props.color
        let className = 'icons-icon'
        return (
            <svg xmlns='http://www.w3.org/2000/svg' width='16' height='16' viewBox='0 0 16 16' fill='none'>
                <g clipPath='url(#clip0_4054_32339)'>
                    <path
                        d='M3.28613 3.28613L12.7135 12.7141'
                        stroke='#0A0A0A'
                        strokeWidth='1.25'
                        strokeLinecap='round'
                        strokeLinejoin='round'
                    />
                    <path
                        d='M7.99967 14.6668C11.6816 14.6668 14.6663 11.6821 14.6663 8.00016C14.6663 4.31826 11.6816 1.3335 7.99967 1.3335C4.31778 1.3335 1.33301 4.31826 1.33301 8.00016C1.33301 11.6821 4.31778 14.6668 7.99967 14.6668Z'
                        stroke='#0A0A0A'
                        strokeWidth='1.25'
                        strokeLinecap='round'
                        strokeLinejoin='round'
                    />
                </g>
                <defs>
                    <clipPath id='clip0_4054_32339'>
                        <rect width='16' height='16' fill='white' />
                    </clipPath>
                </defs>
            </svg>
        )
    }
}
